import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'
import { Button } from 'components/Common/MasterComponents'

export const Wrapper = styled.div`
  display: flex;
  max-width: 576px;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  border-radius: 16px;
  border: 1px solid var(--color-sw-10);
  overflow: hidden;
  background: var(--color-white);

  @media screen and ${breakpoint.s} {
    border: none;
  }
`

export const Title = styled.div`
  font: var(--typography-20-28-semibold);
  color: var(--color-night);
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
  align-items: center;

  ${Button} {
    @media screen and ${breakpoint.s} {
      display: none;
    }
  }
`

export const Subtitle = styled.div`
  font: var(--typography-14-20-regular);
  color: var(--color-sns-80);
  margin-bottom: 16px;
`

export const List = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
`

export const ProductWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--color-sw-10);
  gap: 12px;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

export const Image = styled.img`
  width: 76px;
  height: 76px;
  flex-shrink: 0;
  object-fit: contain;
  align-self: center;
  border-radius: 4px;
  border: 1px solid var(--color-sw-10);
  box-sizing: border-box;
  background: var(--color-white);

  @media screen and ${breakpoint.s} {
    width: 76px;
    height: 128px;
  }
`

export const ImageCounter = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 0 4px;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  bottom: 0;
  gap: 4px;
  border-radius: 4px 0;
  background: var(--color-white);
  border-right: 1px solid var(--color-sw-10);
  border-bottom: 1px solid var(--color-sw-10);
  font: var(--typography-11-16-semibold);
  color: var(--color-sw-60);
`

export const InfoWrapperTitle = styled.div`
  font: var(--typography-14-20-semibold);
  color: var(--color-night);
  margin-bottom: 4px;
`

export const InfoWrapperSubtitle = styled.div`
  font: var(--typography-12-16-regular);
  color: var(--color-sw-60);
`
export const NotCorrect = styled.div`
  display: none;
  font: var(--typography-14-16-semibold);
  color: var(--color-sw-60);
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 0;
  margin-top: 8px;
  cursor: pointer;

  @media screen and ${breakpoint.s} {
    display: flex;

    &:hover {
      color: var(--color-velvet);
    }
  }
`

export const MobileFooter = styled.div`
  display: none;

  @media screen and ${breakpoint.s} {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
`
